// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.securityInfo__CO2RE {
  grid-column: 2;
}

.securityInfoTitle__RtSuJ {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.securityInfoContainer__x5w9r {
  height: calc(100% - 24px);
  min-height: 120px;
  margin-top: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 10px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.authInfoTitle__HHGlf {
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.authInfoDescription__vN3SE {
  color: var(--tables-primary-row-text-main);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-box-trim: none;
  margin-top: 10px;
}

.authInfoButton__QnunF {
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;
  min-width: 100px;
  height: calc(100% - 24px);
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
  cursor: pointer;
  border-radius: 0;
  border: none;
  color: var(--buttons-text-primary);
  background: var(--buttons-surface);
}
.authInfoButton__QnunF:hover {
  background: var(--buttons-hover);
}
.authInfoButton__QnunF:active {
  background: var(--buttons-focused);
}
.authInfoButton__QnunF:disabled {
  background: var(--buttons-disable);
}

.securityInfoSkeleton__Cq8Xc {
  height: calc(100% - 24px);
  min-height: 120px;
  margin-top: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.skeletonText__DvO0t {
  width: 100%;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Profile/components/SecurityInfo/style.module.scss"],"names":[],"mappings":"AA4EA;EACE,cAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AA3EF;;AA8EA;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qDAAA;EACA,wCAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AA3EF;;AA8EA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EAEA,YAAA;EACA,kCAAA;EACA,kCAAA;AA5EF;AA8EE;EACE,gCAAA;AA5EJ;AA8EE;EACE,kCAAA;AA5EJ;AA8EE;EACE,kCAAA;AA5EJ;;AAgFA;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,qDAAA;EACA,wCAAA;AA7EF;;AAgFA;EACE,WAAA;EACA,YAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.securityInfo {\n  grid-column: 2;\n}\n\n.securityInfoTitle {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.securityInfoContainer {\n  height: calc(100% - 24px);\n  min-height: 120px;\n  margin-top: 10px;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 10px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.authInfoTitle {\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 14px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.authInfoDescription {\n  color: var(--tables-primary-row-text-main);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  text-box-trim: none;\n  margin-top: 10px;\n}\n\n.authInfoButton {\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  text-decoration: none;\n  min-width: 100px;\n  height: calc(100% - 24px);\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 12px;\n  padding-right: 12px;\n  cursor: pointer;\n  border-radius: 0;\n\n  border: none;\n  color: var(--buttons-text-primary);\n  background: var(--buttons-surface);\n\n  &:hover {\n    background: var(--buttons-hover);\n  }\n  &:active {\n    background: var(--buttons-focused);\n  }\n  &:disabled {\n    background: var(--buttons-disable);\n  }\n}\n\n.securityInfoSkeleton {\n  height: calc(100% - 24px);\n  min-height: 120px;\n  margin-top: 10px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.skeletonText {\n  width: 100%;\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"securityInfo": `securityInfo__CO2RE`,
	"securityInfoTitle": `securityInfoTitle__RtSuJ`,
	"securityInfoContainer": `securityInfoContainer__x5w9r`,
	"authInfoTitle": `authInfoTitle__HHGlf`,
	"authInfoDescription": `authInfoDescription__vN3SE`,
	"authInfoButton": `authInfoButton__QnunF`,
	"securityInfoSkeleton": `securityInfoSkeleton__Cq8Xc`,
	"skeletonText": `skeletonText__DvO0t`
};
module.exports = ___CSS_LOADER_EXPORT___;
